import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7php3aduqb: FaireBrandEntity = {
  token: "b_7php3aduqb",
  type: "brand",
  name: "Little Dedi",
  avatarUrl:
    "https://cdn.faire.com/fastly/6f408276afedd9a1ce114ce97b82d8f52e739f26ffe28167a2a221bb56ab2210.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/da4db1b04835f9e5cae0d70890d248aa80b269d640812bd106061afe8d008e77.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/6f408276afedd9a1ce114ce97b82d8f52e739f26ffe28167a2a221bb56ab2210.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/da4db1b04835f9e5cae0d70890d248aa80b269d640812bd106061afe8d008e77.jpeg",
  location: "SHERIDAN, WY, USA",
  minimumOrderDollars: 100,
  rating: 0,
  reviewCount: 0,
  isInsider: false,
  description:
    "Dalisa was born out of a passion for crafting textiles that embody beauty, comfort, and respect for the planet. Our journey begins with the careful selection of premium, organic cotton fibers—ethically sourced and certified by the Global Organic Textile Standard (GOTS). At every stage of production, we embrace sustainability, ensuring each step from farming and dyeing to knitting and packaging meets the highest environmental and ethical standards.\n\nOur commitment goes beyond aesthetics: we believe in transparency and traceability, proudly holding certifications such as OEKO-TEX®, ensuring all our textiles are safe for your family and gentle on the earth. Each Dalisa product reflects our dedication to fair labor practices, environmental stewardship, and exceptional quality.\n\nChoosing Dalisa means joining a movement toward a more thoughtful, conscious lifestyle—one stitch at a time.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:51.031Z",
    importedBy: "entity-db-cli",
  },
};
